import is from 'typescript-styled-is'
import styled from '../../../theme'

const InputSquare = styled.input<{ disabled?: boolean }>`
  position: absolute;
  opacity: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  cursor: pointer;

  ${is('disabled')`
  	cursor: unset;
  `}
`

export default InputSquare
